import { DataLoadActionHandler, DataLoadActionType } from "@mcleod/common";
import { ClickEvent, Label, Snackbar } from "@mcleod/components";
import { CompanySettings, GeneralSettings, Navigation, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutShipmentStatusErrors } from "./autogen/AutogenLayoutShipmentStatusErrors";

export class ShipmentStatusErrors extends AutogenLayoutShipmentStatusErrors {

    override onLoad() {
        const isBrokerage: boolean = CompanySettings.get().is_brokerage;
        const isAsset: boolean = CompanySettings.get().is_asset;

        if (isAsset && !isBrokerage) {
            this.homePageSize = "1x1";
            this.labelAsset.visible = false;
            this.panelTotalOrders.visible = false;
            this.panelTotalOrders.fillHeight = false;
            this.panelAssetOnly.visible = true;
        } else if (isBrokerage && (!isAsset || !GeneralSettings.hasEarlyAdoptersAccess())) {
            this.labelAsset.visible = false;
            this.panelAssetOnly.fillHeight = false;
            this.panelAssetOnly.visible = false;
            this.setBrokeragePanelFontSize("large");
            this.setBrokeragePanelPadding(10);
        } else {
            this.panelAssetOnly.fillHeight = false;
            this.panelAssetOnly.visible = false;
            this.setBrokeragePanelFontSize("medium");
            this.homePageSize = "1x2";
        }
    }

    labelOnClick(event: ClickEvent) {
        const urlParams: string[] = [];
        let tabToNavigateTo: string;
        let pageToNavigateTo: string;
        const labelId = event.target.id;
        switch (labelId) {
            case "labelAvailableCount": {
                tabToNavigateTo = "tabAvailableOrders";
                pageToNavigateTo = "lme/powerbroker/BrokeragePlanningMultiProfile";
                urlParams.push(DataLoadActionHandler.createUrlQueryParamString(DataLoadActionType.SELECT_TAB, tabToNavigateTo));
                break;
            }
            case "labelCoveredAmount": {
                tabToNavigateTo = "tabCoveredOrders";
                pageToNavigateTo = "lme/powerbroker/BrokeragePlanningMultiProfile";
                urlParams.push(DataLoadActionHandler.createUrlQueryParamString(DataLoadActionType.SELECT_TAB, tabToNavigateTo));
                break;
            }
            case "labelDeliveredCount": {
                tabToNavigateTo = "tabDeliveredOrders";
                pageToNavigateTo = "lme/powerbroker/BrokeragePlanningMultiProfile";
                urlParams.push(DataLoadActionHandler.createUrlQueryParamString(DataLoadActionType.SELECT_TAB, tabToNavigateTo));
                break;
            }
            case "labelInProgressAmount": {
                tabToNavigateTo = "tabInProgressOrders";
                pageToNavigateTo = "lme/powerbroker/BrokeragePlanningMultiProfile";
                urlParams.push(DataLoadActionHandler.createUrlQueryParamString(DataLoadActionType.SELECT_TAB, tabToNavigateTo));
                break;
            }
            case "labelAssetOnlyTotal": {
                pageToNavigateTo = "lme/dispatch/planning/opsmgmt/OperationsManagementMultiProfile";
                urlParams.push(`planningOrdersCount=${this.activeRow.get("asset_move", 0)}`);
                urlParams.push(`planningEquipmentCount=${this.activeRow.get("asset_equipment", 0)}`);
                break;
            }
            case "labelTotalCountOrder": {
                pageToNavigateTo = "lme/dispatch/planning/opsmgmt/OperationsManagementMultiProfile";
                urlParams.push(`planningOrdersCount=${this.activeRow.get("asset_move", 0)}`);
                urlParams.push(`planningEquipmentCount=${this.activeRow.get("asset_equipment", 0)}`);
                break;
            }
        }
        urlParams.push("shipmentStatusError=true");
        Navigation.navigateTo(pageToNavigateTo + UrlUtil.buildQueryString(urlParams));
    }

    afterExecution() {
        const data = this.mainDataSource.data;
        const message = this.mainDataSource.data[0]?.get("message_order");
        if (!StringUtil.isEmptyString(message) && GeneralSettings.hasEarlyAdoptersAccess()) {
            Snackbar.showWarningSnackbar(message);
        }
    }

    setBrokeragePanelFontSize(fontSize: string) {
        this.labelAvailable.fontSize = fontSize;
        this.labelAvailableCount.fontSize = fontSize;
        this.labelCovered.fontSize = fontSize;
        this.labelCoveredAmount.fontSize = fontSize;
        this.labelInProgress.fontSize = fontSize;
        this.labelInProgressAmount.fontSize = fontSize;
        this.labelDelivered.fontSize = fontSize;
        this.labelDeliveredCount.fontSize = fontSize;
        this.labelTotal.fontSize = fontSize;
        this.labelTotalCount.fontSize = fontSize;
        this.labelTotalOrder.fontSize = fontSize;
        this.labelTotalCountOrder.fontSize = fontSize;
    }

    setBrokeragePanelPadding(padding: number) {
        this.labelAvailableCount.paddingTop = padding;
        this.labelCoveredAmount.paddingTop = padding;
        this.labelInProgressAmount.paddingTop = padding;
        this.labelDeliveredCount.paddingTop = padding;
        this.labelTotalCount.paddingTop = padding;
    }
}
